import React, { useState, useEffect } from 'react'
import ToggleContent from './ToggleContent';
import { Container } from 'reactstrap';
import { isMobile, isTablet, isMobileOnly } from 'react-device-detect'
import { css } from 'emotion';
import { white, gray } from '../../utils/CssGlobalVariables';

const Toggle = (props) => {
    const [toggleOne, setToggleOne] = useState(true)
    const [toggleTwo, setToggleTwo] = useState(false)

    const handleToggleOne = e => {
        e.preventDefault()
        setToggleOne(true)
        setToggleTwo(false)
    }

    const handleToggleTwo = e => {
        e.preventDefault()
        setToggleOne(false)
        setToggleTwo(true)
    }
    const renderContent = (content) => {
        return { __html: content };
    }
    return (
        <Container  className={ (isMobileOnly ? 'mobilelandscapeContainer' : '') + ' toggle-main d-flex align-items-center justify-content-center flex-column'}>
            <div className={isMobileOnly ? 'offers-wrapper d-flex flex-column align-items-center justify-content-center w-100 gap-3' :'offers-wrapper  d-flex align-items-center justify-content-center w-100 gap-3'}>
                <div className={isMobileOnly ? 'homepage-modules-title' :'homepage-modules-title mr-auto'} dangerouslySetInnerHTML={renderContent(props.toggle.title)}></div>
                <div className={isMobileOnly ? 'd-flex align-items-center justify-content-center toggle toggle-container ml-0' :'d-flex align-items-center justify-content-center toggle mr-auto toggle-container mln-10'} role="tablist">
                {/* <a className='toggle-anchor' href='javascript:;'> */}
                {/* <a href='javascript:;' className={css`background-color: ${toggleOne && props.toggle.toggleColor} !important; cursor: ${toggleOne ? 'default' : 'pointer'}` + ' toggle-button-one toggle-anchor d-flex align-items-center justify-content-center rounded-0'} id='Bill pay toggle on' onClick={handleToggleOne}>
                <a aria-label={(isMobile && !isTablet) ? props.toggle.EirOfferToggleMobile[0].ariaLabel : props.toggle.EirOfferToggle[0].ariaLabel} href='javascript:;' className={css`background-color: ${toggleOne && props.toggle.toggleColor} !important; cursor: ${toggleOne ? 'default' : 'pointer'}` + ' toggle-button-one toggle-anchor d-flex align-items-center justify-content-center rounded-0'} id='Bill pay toggle on' onClick={handleToggleOne}>
                    <div className={css`color: ${toggleOne ? gray : props.toggle.toggleColor}` + ' toggleOneText'}>
                        {(isMobile && !isTablet) ? props.toggle.EirOfferToggleMobile[0].toggleTitle : props.toggle.EirOfferToggle[0].toggleTitle}
                    </div>
                </a> */}
                <button
                type="button"
                aria-label={(isMobile && !isTablet) ? props.toggle.EirOfferToggleMobile[0].ariaLabel : props.toggle.EirOfferToggle[0].ariaLabel || undefined}
                role="tab"
                aria-selected={toggleOne}
                id="bill-pay-toggle"
                className={
                    css`
                    background-color: ${toggleOne && props.toggle.toggleColor} !important;
                    cursor: ${toggleOne ? 'default' : 'pointer'};
                    ` +
                    ' toggle-button-one toggle-anchor d-flex align-items-center justify-content-center rounded-0'
                }
                onClick={handleToggleOne}
                onMouseDown={(e) => e.preventDefault()}
                >
                <div
                    className={
                    css`color: ${toggleOne ? gray : props.toggle.toggleColor}` +
                    ' toggleOneText'
                    }
                >
                    {(isMobile && !isTablet)
                    ? props.toggle.EirOfferToggleMobile[0].toggleTitle
                    : props.toggle.EirOfferToggle[0].toggleTitle}
                </div>
                </button>
                {/* </a> */}
                {/* <a className='toggle-anchor' href='javascript:;'> */}
                {/* <a href='javascript:;' className={css`background-color: ${toggleTwo && props.toggle.toggleColor} !important; cursor: ${toggleTwo ? 'default' : 'pointer'}` + ' toggle-button-two toggle-anchor d-flex align-items-center justify-content-center rounded-0'} id='Phone Pay Toggle on' onClick={handleToggleTwo}>
                <a aria-label={(isMobile && !isTablet) ? props.toggle.EirOfferToggleMobile[1].ariaLabel : props.toggle.EirOfferToggle[1].ariaLabel} href='javascript:;' className={css`background-color: ${toggleTwo && props.toggle.toggleColor} !important; cursor: ${toggleTwo ? 'default' : 'pointer'}` + ' toggle-button-two toggle-anchor d-flex align-items-center justify-content-center rounded-0'} id='Phone Pay Toggle on' onClick={handleToggleTwo}>
                    <div className={css`color: ${toggleTwo ? gray : props.toggle.toggleColor}` + ' toggleTwoText'}>
                        {(isMobile && !isTablet) ? props.toggle.EirOfferToggleMobile[1].toggleTitle : props.toggle.EirOfferToggle[1].toggleTitle}
                    </div>
                </a> */}
                <button
                    type="button"
                    role="tab"
                    aria-label={(isMobile && !isTablet) ? props.toggle.EirOfferToggleMobile[1].ariaLabel : props.toggle.EirOfferToggle[1].ariaLabel || undefined}
                    aria-selected={toggleTwo}
                    id="prepay-toggle"
                    className={
                        css`
                        background-color: ${toggleTwo && props.toggle.toggleColor} !important;
                        cursor: ${toggleTwo ? 'default' : 'pointer'};
                        ` +
                        ' toggle-button-two toggle-anchor d-flex align-items-center justify-content-center rounded-0'
                    }
                    onClick={handleToggleTwo}
                    onMouseDown={(e) => e.preventDefault()}
                    >
                    <div
                        className={
                        css`color: ${toggleTwo ? gray : props.toggle.toggleColor}` +
                        ' toggleTwoText'
                        }
                    >
                        {(isMobile && !isTablet)
                        ? props.toggle.EirOfferToggleMobile[1].toggleTitle
                        : props.toggle.EirOfferToggle[1].toggleTitle}
                    </div>
                </button>
                {/* </a> */}
                </div>
            </div>
            {
                toggleOne &&
                <ToggleContent id='1' toggle={(isMobile && !isTablet) ? props.toggle.EirOfferToggleMobile[0] : props.toggle.EirOfferToggle[0]} offerTile={props.offerTile1} />
            }
            {
                toggleTwo &&
                <ToggleContent id='2' toggle={(isMobile && !isTablet) ? props.toggle.EirOfferToggleMobile[1] : props.toggle.EirOfferToggle[1]} offerTile={props.offerTile2} />
            }

        </Container>
    )
}

export default Toggle
